import { AnomalyApi } from '@api/twin/AnomalyApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import { queryOptions, useQueryClient } from '@tanstack/react-query';
import { anomalyQueryKeys } from '../query-keys';

export const useAnomalyQueryOptions = () => {
  const { viewer } = useTeiaViewerContext();
  const api = AnomalyApi(viewer.twinApiClient);

  return (
    projectId: number,
    anomalyId: number,
  ) => queryOptions({
    queryKey: anomalyQueryKeys.anomaly(projectId, anomalyId),
    queryFn: () => api.getAnomaly(projectId, anomalyId),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const usePrefetchAnomaly = (projectId: number,
  anomalyId: number) => {
  const queryClient = useQueryClient();
  const anomalyQueryOptions = useAnomalyQueryOptions();

  return () => queryClient.prefetchQuery({
    ...anomalyQueryOptions(projectId, anomalyId),
  });
};

export const useEnsureAnomaly = (projectId: number,
  anomalyId: number) => {
  const queryClient = useQueryClient();
  const anomalyQueryOptions = useAnomalyQueryOptions();

  return () => queryClient.ensureQueryData({
    ...anomalyQueryOptions(projectId, anomalyId),
  });
};

export const useHasCachedAnomaly = (projectId: number,
  anomalyId: number) => {
  const queryClient = useQueryClient();
  const anomalyQueryOptions = useAnomalyQueryOptions();

  return !!queryClient.getQueryData(anomalyQueryOptions(projectId, anomalyId).queryKey);
};
